import cx from 'classnames'

import Styles from './GifsRow.module.scss'

import { useGiphy } from 'hooks/queries/useGiphy'
import { useImageMenuContext } from '../ImageMenuContext'

import { Carousel } from 'components/Carousel/Carousel'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Button } from 'blaze-ui/Button'
import { SelectableFile } from '../SelectableFile/SelectableFile'

export const GifsRow = () => {
  const { setProvider, toggleSelectedImage, selectedImages, hiddenProviders } = useImageMenuContext()
  const { data } = useGiphy({ perPage: 24 })
  const results = (data?.pages || []).flatMap((page) => page.data)

  const images = results.map((item) => ({
    url: item.images.original.url,
  }))

  if (hiddenProviders.includes('gifs')) return null

  return (
    <div className={cx(Styles.row, Styles.uploadsRow, Styles.container)}>
      <div className={Styles.rowHeader}>
        <Heading level={4} color="var(--dark-80)">
          GIFs
        </Heading>
        <Button size="sm" variant="ghost" onPress={() => setProvider('gifs')} data-testid="see-all-gifs-button">
          See All
        </Button>
      </div>
      <Carousel offset={20}>
        {images.map((image) => (
          <SelectableFile
            key={image.url}
            onSelect={() => toggleSelectedImage({ ...image, provider: 'gifs' })}
            isSelected={selectedImages.some((i) => i.url === image.url)}
          >
            <img key={image.url} src={image.url} alt={image.url} />
          </SelectableFile>
        ))}
      </Carousel>
    </div>
  )
}
